import template from './entries-list.html'

export let entriesList = {
	bindings: {
		details : '<',
		activity: '=',
		type    : '<',
	},
	template    : template,
	controllerAs: 'vm',
	controller  : [ '$stateParams', 'ReviewSrv', 'WorkPlanModalSrv', 'CssClasses', 'Validations', '$rootScope',
		'GlobalSrv', '$state', 'Util',
		function entriesListCtrl ($stateParams, ReviewSrv, WorkPlanModalSrv, CssClasses, Validations, $rootScope,
			GlobalSrv, $state, Util) {
			const setDate = Util.setDate
			const textColor = CssClasses.textColor
			const icons = CssClasses.icons
			const currentStage = ($stateParams.currentStage) ? $stateParams.currentStage : $stateParams.stage
			const currentModule = $state.current.module
			let _entries = []
			let inExecution = Validations.inExecution(currentStage)
			let isPositionByDelegationType = Validations.isPositionByDelegationType(this.activity)
			let isColaborationSpaceType = Validations.isColaborationSpaceType(this.activity)
			let isProjectDesignType = Validations.isProjectDesignType(this.activity)
			let isSubjectType = Validations.isSubjectType(this.activity)

			angular.extend(this, {
				// variables
				get entries () {
					return _entries
				},
				set entries (value) {
					_entries = value

					return value
				},
				title            : 'Ejecución ',
				contentHeaderCSS : [ 'col-md-6', 'no-padding', 'font-normal', 'text-xs' ],
				headingCSS       : [ isSubjectType ? 'col-md-3' : 'col-md-2', 'no-padding', 'text-center', 'font-normal', 'text-xs' ],
				contentCSS       : [ isSubjectType ? 'col-md-3' : 'col-md-2', 'no-padding', 'text-center', textColor.blue, 'text-xs' ],
				contentHeaderCSS2: [ 'col-md-3', 'no-padding', 'font-normal', 'text-xs' ],
				edit             : icons.edit,
				executionFinish  : this.details.executionFinish,
				itemRequired     : 0,
				isBlocked        : 1,
				disableEdit      : 'disabled',
				evidence         : '',
				evidenceName     : '',

				// methods
				registerExecution: registerExecution,
				allowRegistry    : allowRegistry(),
				inExecution      : Validations.inExecution(currentStage),
				inEvaluation     : Validations.inEvaluation(currentStage),
				inReviewExecution: Validations.inReviewExecution(currentStage),
				inConsolidation  : Validations.inConsolidation(currentModule),
				inExtension      : Validations.inExtension(currentModule),
				inInvestigation  : Validations.inInvestigation(currentModule),
				isSubjectType    : isSubjectType,
				inHistory        : $stateParams.inHistory,
				viewFile         : viewFile,
			})

			this.$onInit = () => {
				getExecutionEntries(this.activity).then((data) => {
					this.entries = data
					this.isBlocked2 = false || this.inHistory
					this.entries.forEach(child => {
						child.status = child.status || checkState(child.startDate, child.endDate, setDate(new Date()))
					})
					this.executionFinish = this.details.executionFinish

					//this.details.isBlocked ||
					if (this.activity.origin == 3) {
						this.isBlocked = ((this.activity.origin == 3 && this.activity.checkStatus == 0) || this.inHistory)
						this.isBlocked2 = ((this.activity.origin == 3 && this.activity.checkStatus == 0) || this.inHistory)
					} else {
						this.isBlocked = this.details.isBlocked
					}

					this.itemRequired = this.details.isItemRequired

					this.disableEdit = (this.executionFinish || this.isBlocked) ? 'disabled' : ''
				})

				this.title = this.type ? 'Registro de ejecución de Docencia Directa' : this.title
			}

			function allowRegistry () {
				return inExecution && !isPositionByDelegationType
			}

			function getTotalHours (entries) {
				return entries.reduce((acc, entry) => (acc += entry.hoursExecuted), 0)
			}

			function checkState (start, end, now) {
				if (start < now && now < end) {
					return 'En curso'
				} else if (start > now) {
					return 'No iniciado'
				} else if (now > end) {
					return 'Finalizado'
				} else {
					return 'Desconocido'
				}
			}

			function registerExecution (children, action) {
				let header = {
					children    : children,
					action      : action,
					itemRequired: this.itemRequired,
					isShowState : (this.inInvestigation && isColaborationSpaceType) || (this.inInvestigation && isProjectDesignType),
				}
				let diffHours = getTotalHours(this.entries)
				let totalHours = 0

				WorkPlanModalSrv.setVariable(header)
				WorkPlanModalSrv.registerExecution().then((promise) => {
					let header = WorkPlanModalSrv.getVariable()

					if (header) {
						header.startDate = header.startDate === 'Invalid date' ? null : header.startDate
						header.endDate = header.endDate === 'Invalid date' ? null : header.endDate

						if (header.action === 'ADD') {
							header.evidence = header.fileUrl
							this.entries.push(header)
						} else {
							children.hoursExecuted = header.hoursExecuted
							children.descriptionExecution = header.descriptionExecution
							children.startDate = header.startDate
							children.endDate = header.endDate
							children.status = header.status
							children.dateCreation = header.dateCreation
							children.evidence = header.fileUrl
							children.evidenceName = header.attachFile
							children.fileName = header.attachFile
						}

						totalHours = getTotalHours(this.entries)
						diffHours = totalHours - diffHours
						this.activity.totalHoursExecuted += diffHours
						$rootScope.$emit('rootScope:execHours', 'execHours!')

						if (totalHours === 0) {
							// this.disableEdit = 'disabled'
							this.disableEdit = ''
							this.isBlocked = 1
							// GlobalSrv.notify($rootScope, 'isBlocked', this.isBlocked)
						}

						GlobalSrv.notify($rootScope, 'hoursChanged', totalHours)
					}
				})
			}

			function getExecutionEntries (activity) {
				let header = {
					workplanTeacherActivityId: activity.workplanTeacherActivityId,
				}

				return ReviewSrv.getExecutionEntries.post(header).$promise.then((dataReturn) => {
					if (dataReturn.status) {
						return dataReturn.data
					}
				})
			}

			function viewFile (url) {
				WorkPlanModalSrv.setVariable(url)
				WorkPlanModalSrv.viewFile().then((promise) => {
				})
			}
		},
	] }



// WEBPACK FOOTER //
// ./src/app/u-faculty/components/activities-review/activity-details/entries-list.js